module.exports = __webpack_public_path__ + "static/media/close.359cec34.svg";